// extracted by mini-css-extract-plugin
module.exports = {"CardItem":"styles_CardItem__1sL1v","CardItem_iconWrapper":"styles_CardItem_iconWrapper__1cvgc","CardItem_text":"styles_CardItem_text__2Iw_E"};